/*const isAlign = (element, canvas, offset = 10, direction = 'x') => {
  const ep = element.getCenterPoint()
  const cp = canvas.getVpCenter()
  return ep[direction] - cp[direction] <= offset
}

const alignTest = (element, canvas) => {
  const xAlign = isAlign(element, canvas, 20, 'x')
  const yAlign = isAlign(element, canvas, 20, 'y')
}

export {
  isAlign
}*/

export default class Alignement {
  constructor(target) {
    this.target = target
    this.VLines = null
    this.HLines = null
    this.offset = 10
  }

  draw() {
    this._createLines(this.target.canvas)
  }

  _createLines() {
    const lc = {
      stroke: '#00F',
      strokeWidth: 2,
      selectable: false,
      opacity: 1,
      visible: false,
      hoverCursor: 'default',
      evented: false
    }
    const cp = this.target.canvas.getVpCenter()
    this.VLines = new fabric.Line([cp.x, 0, cp.x, cp.y * 2], lc)
    this.HLines = new fabric.Line([0, cp.y, cp.x * 2, cp.y], lc)
    this.HLines.excludeFromExport = true
    this.VLines.excludeFromExport = true
    /*canvas.add(this.VLines)
    canvas.add(this.HLines)*/
    //canvas.requestRenderAll()
  }

  elementIsAligned(element) {
    const cp = this.target.canvas.getVpCenter()
    const ep = element.getCenterPoint()
    if (Math.abs(ep.x - cp.x) <= this.offset) {
      this.VLines.set({
        visible: true
      })
      this.target.canvas.insertAt(this.VLines, element.layer)
    } else {
      this.VLines.set({
        visible: false
      })
      this.target.canvas.remove(this.VLines)
    }
    if (Math.abs(ep.y - cp.y) <= this.offset) {
      this.HLines.set({
        visible: true
      })
      this.target.canvas.insertAt(this.HLines, element.layer - 1)
    } else {
      this.HLines.set({
        visible: false
      })
      this.target.canvas.remove(this.HLines)
    }
  }

  clear() {
    this.target.canvas.remove(this.VLines)
    this.target.canvas.remove(this.HLines)
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/elements/Alignement.js